import React from 'react';
import { Handshake, TrendingUp, Users } from 'lucide-react';
export function PartnerWithUs() {
  return <section id="partner" className="py-20 bg-stone-50" data-id="element-318">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-319">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-320">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-321">
            <div className="p-10 lg:p-16 flex flex-col justify-center" data-id="element-322">
              <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-6" data-id="element-323">
                Partner With Us
              </h2>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-324">
                We believe in the power of collaboration. Whether you are a
                supplier, distributor, or agricultural innovator, we are open to
                partnerships that drive mutual growth and sustainable
                development in the dairy sector.
              </p>

              <div className="space-y-6" data-id="element-325">
                <div className="flex items-start" data-id="element-326">
                  <Handshake className="h-6 w-6 text-amber-600 mr-4 mt-1" data-id="element-327" />
                  <div data-id="element-328">
                    <h4 className="font-bold text-gray-900" data-id="element-329">
                      Strategic Alliances
                    </h4>
                    <p className="text-gray-500 text-sm" data-id="element-330">
                      Joint ventures for expansion and market access.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-331">
                  <Users className="h-6 w-6 text-amber-600 mr-4 mt-1" data-id="element-332" />
                  <div data-id="element-333">
                    <h4 className="font-bold text-gray-900" data-id="element-334">
                      Community Growth
                    </h4>
                    <p className="text-gray-500 text-sm" data-id="element-335">
                      Programs that benefit local farmers and youth.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-336">
                  <TrendingUp className="h-6 w-6 text-amber-600 mr-4 mt-1" data-id="element-337" />
                  <div data-id="element-338">
                    <h4 className="font-bold text-gray-900" data-id="element-339">Innovation</h4>
                    <p className="text-gray-500 text-sm" data-id="element-340">
                      Testing and implementing new agricultural technologies.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-10" data-id="element-341">
                <a href="#contact" className="inline-block px-8 py-3 bg-green-900 text-white font-semibold rounded-lg hover:bg-green-800 transition-colors" data-id="element-342">
                  Get in Touch
                </a>
              </div>
            </div>

            <div className="relative h-64 lg:h-auto" data-id="element-343">
              <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=1613&q=80" alt="Handshake in field" className="absolute inset-0 w-full h-full object-cover" data-id="element-344" />
              <div className="absolute inset-0 bg-green-900/20" data-id="element-345"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}